module.exports = "/work-site/img/company.a39971a4.png";